import { ClipLoader } from 'react-spinners';

function PlayerLoad() {
  return (
    <div className={'flex-center h-full w-full'} style={{ height: 'calc(100vh - 140px)' }}>
      <ClipLoader />
    </div>
  );
}

export default PlayerLoad;
